// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__15ger","header":"ReportDetails_header__3gj7X","title":"ReportDetails_title__37ZD7","left":"ReportDetails_left__g9Qum"};